import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
import styles from "./styles.module.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// Firefox's font sanitizer (OTS) rejects some embedded CFF fonts (e.g. KE bills),
// leaving glyphs as boxes. Drawing glyphs as canvas paths bypasses it. Kept
// Firefox-only so other browsers keep the faster FontFace rendering. Module-level
// so react-pdf doesn't see a new options object (and reload) on every render.
const isFirefox =
  typeof navigator !== "undefined" && /firefox/i.test(navigator.userAgent);
const DOCUMENT_OPTIONS = isFirefox ? { disableFontFace: true } : undefined;

const PdfPageViewer = ({ fileUrl, setHasError = false, setIsLoading }) => {
  const containerRef = useRef(null);
  const [pageWidth, setPageWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return undefined;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      window.requestAnimationFrame(() => setPageWidth(width));
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={containerRef} className={styles.wrapper}>
      <Document
        file={fileUrl}
        options={DOCUMENT_OPTIONS}
        onLoadSuccess={({ numPages: total }) => {
          setNumPages(total);
          setIsLoading?.(false);
        }}
        loading={null}
        onLoadError={() => {
          setHasError(true);
          setIsLoading?.(false);
        }}
      >
        {pageWidth > 0 &&
          Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`bill_page_${index + 1}`}
              pageNumber={index + 1}
              width={pageWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              className={styles.page}
            />
          ))}
      </Document>
    </Box>
  );
};

export default PdfPageViewer;
